import React from 'react';

function FacebookIcon() {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='16' cy='16' r='16' fill='#F8F5EF' />
			<g clipPath='url(#clip1)'>
				<path
					d='M19.1977 9.5879H20.9505V6.5351C20.6481 6.4935 19.6081 6.3999 18.3969 6.3999C15.8697 6.3999 14.1385 7.9895 14.1385 10.9111V13.5999H11.3497V17.0127H14.1385V25.5999H17.5577V17.0135H20.2337L20.6585 13.6007H17.5569V11.2495C17.5577 10.2631 17.8233 9.5879 19.1977 9.5879Z'
					fill='#CF004F'
				/>
			</g>
			<defs>
				<clipPath id='clip1'>
					<rect
						width='19.2'
						height='19.2'
						fill='white'
						transform='translate(6.40002 6.3999)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default FacebookIcon;
